import React from 'react';
import {makeStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import HotspotGrid from './HotspotGrid'
import Box from '@mui/material/Box';
import ImageZoom from 'react-medium-image-zoom'
import CheckIcon from '@mui/icons-material/CheckCircleOutline';
import PriorityIcon from '@mui/icons-material/PriorityHighOutlined';
import Button from '@mui/material/Button';
import Pagination from '@mui/material/Pagination';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import {Map} from '@mui/icons-material';
import ScrollContainer from 'react-indiana-drag-scroll';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import ClearIcon from '@mui/icons-material/Clear';
import Cookies from 'universal-cookie';
import {useAuth} from "../utils/useAuth";
import {Input, InputLabel} from "@mui/material";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '20px',
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        margin: 'auto',
        maxWidth: 'auto',
        height: '500px'
    },
    card: {
        padding: theme.spacing(1),

        height: '37px',
        'min-width': '160px',
        fontFamily: 'GucciSans-Bold',
        marginRight: '10px',
        marginLeft: '2px',
        marginTop: '8px',
        'box-shadow': '2px 2px #c0bbbb5c',
        'scroll-snap-align': 'center'
    },
    removeFilters: {
        height: '37px',
        'min-width': '150px',
        fontFamily: 'GucciSans-Bold',
        color: "#ca0000",
        marginRight: '10px',
        marginLeft: '2px',
        marginTop: '8px',
        'box-shadow': '2px 2px #c0bbbb5c',
        'scroll-snap-align': 'center'
    },
    filterBy: {
        padding: theme.spacing(1),
        height: '37px',
        'min-width': '100px',
        fontFamily: 'GucciSans-Bold',
        marginRight: '10px',
        marginLeft: '2px',
        marginTop: '20px',
        'scroll-snap-align': 'center'
    },
    image: {
        width: '100%',
        height: '90%',
        alignItems: 'center',
        justify: 'center'

    },
    img: {
        display: 'block',
        height: '400px',
    },
}));

export default function DisplayGrid(props) {
    const classes = useStyles()
    const {getAccessToken} = useAuth();

    const [loadingHotspots, setLoadingHotspots] = React.useState(false);

    const [selectedWishlist, setSelectedWishlist] = React.useState("0")
    const [elementsPerPage, setElementsPerPage] = React.useState(10)
    const [byEvent, setEvent] = React.useState("0")
    const [byOrder, setOrder] = React.useState("0")
    const [byArea, setArea] = React.useState("0")
    const [byDisplayType, setDisplayType] = React.useState("0")
    const [byDisplayName, setDisplayName] = React.useState("")
    const [debouncedDisplayName, setDebouncedDisplayName] = React.useState("")
    const [numberOfProducts, setNumberOfProducts] = React.useState(0)
    const [value, setValue] = React.useState('all');
    const [open, setOpen] = React.useState(false);
    const [openWishlistDialog, setOpenWishlistDialog] = React.useState(false);
    const [addWishlistDialog, setOpenAddWishlistDialog] = React.useState(false);
    const [openFormDialog, setOpenFormDialog] = React.useState(false);
    const [completed, setCompleted] = React.useState(false);
    const [selectedDisplay, setSelectedDisplay] = React.useState("");
    const [wishlists, setWishlists] = React.useState([]);

    const [noteValue, setNote] = React.useState('');
    const [wishlistName, setWishlistName] = React.useState('');
    const [wishlistClient, setWishlistClient] = React.useState('');

    const [state, setState] = React.useState({
        openSuccess: false,
        openError: false,
        vertical: 'top',
        horizontal: 'right',
        successMessage: '',
        errorMessage: ''
    });
    const {vertical, horizontal, openSuccess, successMessage, openError, errorMessage} = state;
    const handleClickOpen = (completed, display) => {
        setSelectedDisplay(display.id)
        setCompleted(completed)
        setOpen(true);
    };

    const handleClickDisplayWishlist = (bool, selectedDisplay) => {
        setSelectedDisplay(selectedDisplay)
        setOpenWishlistDialog(bool)
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseWishlistDialog = () => {
        setOpenWishlistDialog(false);
    };

    const handleAddWishlistDialog = (bool) => {
        setOpenAddWishlistDialog(bool);
    };

    const handleOpenFormDialog = (bool) => {
        setOpenFormDialog(bool)
        if (!bool) {
            setWishlistName('')
            setWishlistClient('')
            setValue('')
        }
    }

    const handleChangeNote = (event) => {
        setNote(event.target.value);
    };

    const handleChangeName = (event) => {
        setWishlistName(event.target.value)
    }
    const handleChangeDisplayName = (event) => {
        setDisplayName(event.target.value)
    }

    const handleChangeClient = (event) => {
        setWishlistClient(event.target.value)
    }

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        props.setCurrentPage(newPage - 1);
    };

    function renderableItems() {
        const filtered = search(props.searchText)

        if (value === "complete") {
            return filtered.filter(f => f.completed === true)
        } else if (value === "incomplete") {
            return filtered.filter(f => f.completed === false)
        } else {
            return filtered
        }
    }

    function search(searchText) {
        if (!searchText) return props.displays || [];

        const lowerSearch = searchText.toLowerCase();
        const toDisplay = [];

        props.displays.forEach(display => {
            let match = false;

            if (display.name.toLowerCase().includes(lowerSearch)) match = true;

            if (!match && display.hotspots?.some(h => h.products?.some(p =>
                p.name.toLowerCase().includes(lowerSearch) ||
                p.smc.toLowerCase().includes(lowerSearch)
            ))) match = true;

            if (match) toDisplay.push(display);
        });

        return toDisplay;
    }

    const fetchDisplays = async () => {
        try {
            const token = await getAccessToken();
            if (!token) throw new Error("Not authenticated");

            const cookies = new Cookies();
            const hashCode = cookies.get('hashCode') || "";

            let fetchLink = `${process.env.REACT_APP_API_ENDPOINT}displays?eventID=${props.selectedEvent.id}`;
            if (byArea !== "0") fetchLink += `&areaID=${byArea}`;
            if (byOrder !== "0" && byOrder !== "alpha") fetchLink += `&orderBy=${byOrder}`;
            if (byDisplayType !== "0") fetchLink += `&typeID=${byDisplayType}`;
            if (debouncedDisplayName !== "") fetchLink += `&displayName=${debouncedDisplayName}`;
            props.setCurrentPage(0);

            const res = await fetch(fetchLink, {
                method: 'GET',
                headers: {
                    Authorization: token + hashCode
                }
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();


            setNumberOfProducts(
                data.reduce(
                    (acc, d) =>
                        acc + d.hotspots.reduce(
                            (hAcc, h) => hAcc + h.products.length,
                            0
                        ),
                    0
                )
            );

            props.setDisplays(data);
            props.setLoading(false);
        } catch (err) {
            console.error("fetchDisplays error:", err);
        }
    };


    React.useEffect(() => {
        const timer = setTimeout(() => setDebouncedDisplayName(byDisplayName), 2000);
        return () => clearTimeout(timer);
    }, [byDisplayName]);

    React.useEffect(() => {
        if (!props.selectedEvent?.id) return;
        props.setLoading(true);

        let isMounted = true;

        fetchDisplays();

        return () => {
            isMounted = false;
        };
    }, [
        props.selectedEvent?.id,
        byArea,
        byOrder,
        byDisplayType,
        debouncedDisplayName
    ]);



    // async function getWishlists() {
    //     console.log("getWishlists displayGrid")
    //     var myHeaders = new Headers();
    //     let cookies = new Cookies()
    //     let accessToken = await aquireToken2();
    //     myHeaders.append("Authorization", accessToken + cookies.get('hashCode'));
    //
    //     var requestOptions = {
    //         method: 'GET',
    //         headers: myHeaders,
    //         redirect: 'follow'
    //     }
    //
    //     const res = await fetch("${process.env.REACT_APP_API_ENDPOINT}wishlists", requestOptions)
    //         .then(response => response.json())
    //         .then(result => {
    //             setWishlists(result)
    //             props.setLoading(false)
    //         })
    //         .catch(error => {
    //             console.log('error', error)
    //             props.setLoading(false)
    //         });
    //
    //     return res
    // }

    async function addWishlist() {

        /*
        handleOpenFormDialog(false)
        props.setLoading(true)

        var myHeaders = new Headers();
        let cookies=new Cookies()
        let token = await aquireToken2();

        myHeaders.append("Authorization", token + cookies.get('hashCode'));
        myHeaders.append("Content-Type", "application/json");

        let today = new Date();
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = today.getFullYear();
        today = dd + '/' + mm + '/' + yyyy;

        var raw = JSON.stringify({
            id: parseInt(+new Date()/1000).toString(),
            name: wishlistName,
            lastEdit: today,
            note: noteValue,
            client: wishlistClient,
            products: [],
            timestamp: parseInt(+new Date()/1000).toString(),
            mail: '',
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        }

        const res = await fetch("${process.env.REACT_APP_API_ENDPOINT}wishlists", requestOptions)
            .then(response => response.json())
            .then(result => {
                //setState({ openSuccess: true, openError: false, successMessage: "Wishlist added successfully!" });
            })
            .catch(error => {
                console.log('error', error)
                //setState({ loading: false, openError: true, openSuccess: false, errorMessage: "Something went wrong." });
            });

        return res
        */
    }


    async function markDisplay() {
        // const displayToUpdate = await DataStore.query(Display, selectedDisplay);
        // await DataStore.save(Display.copyOf(displayToUpdate, item => {
        //     if (completed) {
        //         item.complete = false
        //     } else {
        //         item.complete = true
        //     }

        // })).then((value) => {
        //     handleClose()
        //     aquireToken()
        // });
    }

    async function addDisplayInWishlist() {
        handleCloseWishlistDialog(true)
        handleAddWishlistDialog(true)
    }

    async function newWishlist() {
        handleAddWishlistDialog(false)
        handleOpenFormDialog(true)
    }

    async function removeFilters() {
        setArea("0");
        setEvent("0");
        setOrder("0");
        setDisplayType("0");
        setDisplayName("");
    }

    async function getWishList() {
        props.setWishlist(true)
    }

    async function getMap() {

        props.setMap(true)
    }

    return (
        <div className={classes.root}>
            {props.loading ?
                <div style={{textAlign: 'center'}}>
                    <Typography style={{paddingBottom: '20px'}} variant="h6">Loading...</Typography>
                    <CircularProgress/>
                </div>
                :
                <div>

                    <Grid container alignItems="center" justifyContent="center" spacing={2}>
                        <Grid item xs={3}>
                            <div className='flex'>
                                <Paper className={classes.card}>
                                    <div className='data_usage'>
                                        <div className='gucci_text_bold'> Displays: {renderableItems().length}</div>
                                    </div>
                                </Paper>
                                <Paper className={classes.card}>
                                    <div className='data_usage'>
                                        <div className='gucci_text_bold'> Products: {numberOfProducts}</div>
                                    </div>
                                </Paper>
                            </div>
                            <div className='flex'>
                                <FormControl style={{display: 'contents', marginTop: '10px', marginBottom: '10px'}}
                                             component="fieldset">

                                    <div className="wrapper">
                                        <RadioGroup style={{ display: 'contents' }} row aria-label="gender" name="gender1" value={value} onChange={handleChange}>
                                            <FormControlLabel key={1} className="option option-1" value="all" control={<Radio color="default" />} label="All" />
                                            <FormControlLabel key={2} className="option option-2" value="complete" control={<Radio color="default" />} label="Complete" />
                                            <FormControlLabel key={3} className="option option-3" value="incomplete" control={<Radio color="default" />} label="Incomplete" />
                                        </RadioGroup>
                                    </div>


                                    <Select
                                        className='gucci_text select_filter'
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined value-sel"
                                        value={elementsPerPage}
                                        onChange={e => setElementsPerPage(e.target.value)}
                                        label="Element"
                                    >
                                        <MenuItem key={0} value="" >
                                        </MenuItem>
                                        <MenuItem key={1} value={10}>10</MenuItem>
                                        <MenuItem key={2} value={20}>20</MenuItem>
                                        <MenuItem key={3} value={50}>50</MenuItem>
                                    </Select>

                                </FormControl>
                            </div>

                            <div className='flex'>
                                <div className={classes.filterBy}>
                                    <div className='gucci_text_bold'>Filter by:</div>
                                </div>
                                <FormControl style={{ minWidth: 200, marginTop: 5, marginRight: 10 }}>
                                    <Select
                                        fullWidth
                                        className='gucci_text select_filter'
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined value-sel"
                                        variant="standard"
                                        value={byOrder}
                                        onChange={e => setOrder(e.target.value)}
                                        label="Order"
                                    >
                                        <MenuItem key={0} value="0" >Select order type</MenuItem>
                                        <MenuItem key={1} value="alpha" >Alphabetical</MenuItem>
                                        <MenuItem key={2} value="timestamp" >Last modified date</MenuItem>

                                    </Select>
                                </FormControl>
                                <FormControl style={{ minWidth: 200, marginTop: 5, marginRight: 10 }}>
                                    <Select
                                        fullWidth
                                        className='gucci_text select_filter'
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined value-sel"
                                        variant="standard"
                                        value={byArea}
                                        onChange={e => setArea(e.target.value)}
                                        label="Order"
                                    >
                                        <MenuItem value="0" >Select area</MenuItem>
                                        {props.areas.length > 0 ?
                                            props.areas.map(area =>
                                                <MenuItem key={area.id} value={area.id} >{area.name}</MenuItem>
                                            )
                                            : ''}
                                    </Select>
                                </FormControl>
                                <FormControl style={{ minWidth: 200, marginTop: 5, marginRight: 10 }}>
                                    <Select
                                        fullWidth
                                        className='gucci_text select_filter'
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined value-sel"
                                        variant="standard"
                                        value={byDisplayType}
                                        onChange={e => setDisplayType(e.target.value)}
                                        label="Order"
                                    >
                                        <MenuItem value="0" >Select display type</MenuItem>
                                        {props.displayTypes.length > 0 ?
                                            props.displayTypes.map(type =>
                                                <MenuItem key={type.id} value={type.id} >{type.name}</MenuItem>
                                            )
                                            : ''}
                                    </Select>
                                </FormControl>
                                <FormControl style={{ minWidth: 200, marginTop: 7, marginRight: 10 }}>
                                    <InputLabel id="demo-simple-select-outlined-label">Display name</InputLabel>
                                    <Input id="demo-simple-select-outlined value-sel" value={byDisplayName} onChange={handleChangeDisplayName} />
                                </FormControl>
                                <Button className="red" style={{ height: '20px', marginTop: "30px" }} startIcon={<ClearIcon color='error' />} onClick={() => removeFilters()} />
                            </div>
                        </Grid>

                        <Grid item xs={6} className="right">


                        </Grid>
                        <Grid item xs={2} className="right">
                            {props.selectedEvent.imageUrl ?
                                <Button className='red template_button pl-15 mr-10' startIcon={<Map color='red'/>}
                                        onClick={() => getMap()}>
                                    <div className='gucci_text_bold ml-8 '> Map</div>
                                </Button>
                                : ''}
                            <Button className='red template_button pl-15' startIcon={<LocalMallIcon color='red'/>}
                                    onClick={() => getWishList()}>
                                <div className='gucci_text_bold ml-8 '> Wishlist</div>
                            </Button>

                        </Grid>
                    </Grid>
                    {props.displays.length > 0 ?
                        <React.Fragment>
                            <Pagination style={{ marginTop: '10px', marginBottom: '10px', marginLeft: '5%' }} onChange={handleChangePage} page={props.currentPage + 1} count={Math.ceil(renderableItems().length / elementsPerPage)} />

                            {renderableItems().slice(props.currentPage * elementsPerPage, (props.currentPage + 1) * elementsPerPage).map((display) => (
                                <Grid container alignItems="center" justifyContent="center" spacing={2} key={display.id} >
                                    <Grid item xs={3} >
                                        <Paper className={classes.paper}>

                                            <Typography variant="h6" className='grid summary ml-10' >
                                                <div className='flex center'>
                                                    <Box className='gucci_text_bold' style={{ display: 'inline-block' }} fontWeight="fontWeightBold" >{" " + display.name + " "}</Box>
                                                </div>
                                                <Box className='gucci_text text_center' style={{ display: 'inline-block' }}>  {display.area ? display.area.name : ''}</Box>
                                            </Typography>

                                            <ButtonBase className={classes.image} style={{ height: '72%', marginBottom: '5px' }}>
                                                <ImageZoom
                                                    image={{
                                                        src: display.imageLink400,
                                                        // className: classes.image,
                                                        style: { height: '90%' },
                                                    }}
                                                    zoomImage={{
                                                        src: display.imageLink400,
                                                        alt: ''
                                                    }}
                                                />
                                            </ButtonBase>
                                            <div className='gucci_text_bold grid summary_button'><div style={{ marginBottom: '5px' }}>{display.id} </div>
                                                <Box className='gucci_text' style={{ display: 'inline-block', marginLeft: '10px' }}>
                                                    <div className='flex center'>
                                                        {display.completed ?
                                                            <Button
                                                                onClick={() => handleClickOpen(true, display)}
                                                                disabled={false}
                                                                color="primary"
                                                                startIcon={<CheckIcon />}
                                                                className='complete_button'>
                                                            </Button>
                                                            :
                                                            <Button
                                                                onClick={() => handleClickOpen(false, display)}
                                                                disabled={false}
                                                                color="primary"
                                                                startIcon={<PriorityIcon className='icon'/>}
                                                                className='complete_button'>
                                                            </Button>
                                                        }
                                                        {/*!display.completed ?
                                                    <Button
                                                        onClick={() => handleClickDisplayWishlist(true, display)}
                                                        disabled={false}
                                                        color="primary"
                                                        startIcon={<StarOutlineIcon />}
                                                        className='complete_button'>
                                                    </Button>
                                                    :
                                                    <Button
                                                        onClick={() => handleClickDisplayWishlist(false, display)}
                                                        disabled={false}
                                                        color="primary"
                                                        startIcon={<StarIcon className='icon' />}
                                                        className='complete_button'>
                                                    </Button>
                                            */}
                                                    </div>
                                                </Box>
                                            </div>
                                        </Paper>

                                    </Grid>
                                    <Grid item xs={8}>

                                        <Paper className={classes.paper}>
                                            <ScrollContainer className="slider">
                                                <HotspotGrid
                                                    key={`hotspotgrid-${display.id}`}
                                                    user={props.user}
                                                    loadingHotspots={loadingHotspots}
                                                    setLoadingHotspots={setLoadingHotspots}
                                                    setDisplays={props.setDisplays}
                                                    searchText={props.searchText}
                                                    fetchDisplays={fetchDisplays}
                                                    value={value}
                                                    currentPage={props.currentPage}
                                                    display={display}
                                                    displays={props.displays}
                                                ></HotspotGrid></ScrollContainer>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            ))
                            }

                            < Pagination style={{
                                marginTop: '30px',
                                marginBottom: '30px',
                                marginLeft: '5%',
                                fontFamily: 'GucciSans-Bold'
                            }} onChange={handleChangePage} page={props.currentPage + 1}
                                         count={Math.ceil(renderableItems().length / elementsPerPage)}/>
                        </React.Fragment>

                        :
                        <div className='error_message'><p>No results for applied filters.</p></div>}


                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle
                            id="alert-dialog-title">{"Do you want to mark this display as"} {completed ? "incomplete?" : "complete?"}</DialogTitle>
                        <DialogContent>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                No
                            </Button>
                            <Button onClick={() => markDisplay()} color="primary" autoFocus>
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog>


                    {/* */}
                    <Dialog
                        open={openWishlistDialog}
                        onClose={handleCloseWishlistDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Do you want to "} {completed ? "remove" : "insert"} {" all display products "} {completed ? "from" : "in"} {" wishlist?"}
                        </DialogTitle>
                        <DialogContent>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseWishlistDialog} color="primary" className="red">
                                No
                            </Button>
                            <Button onClick={() => addDisplayInWishlist()} color="primary" className="red" autoFocus>
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <Dialog
                        open={addWishlistDialog}
                        onClose={handleAddWishlistDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            Add products to your wishlist
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Select the wishlist to add the products to
                            </DialogContentText>
                            <Select
                                fullWidth
                                className='gucci_text'
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined value-sel"
                                value={selectedWishlist}
                                onChange={e => setSelectedWishlist(e.target.value)}
                                label="Select a wishlist"
                            >
                                <MenuItem value="0" >Select a wishlist</MenuItem>
                                {wishlists.length > 0 ?

                                    wishlists.map(w =>
                                        <MenuItem key={w.id} value={w.id}>
                                            {w.name}
                                        </MenuItem>
                                    )
                                    :
                                    <MenuItem value={''}>
                                        No wishlists
                                    </MenuItem>
                                }
                            </Select>
                            <br/>
                            <br/>
                            <DialogContentText>
                                or create a
                                <Button onClick={() => newWishlist()} className="red">
                                    new wishlist
                                </Button>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleAddWishlistDialog(false)} className="red" color="primary">
                                cancel
                            </Button>
                            <Button onClick={() => addDisplayInWishlist()} className="red" color="primary" autoFocus>
                                add
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openFormDialog}
                        onClose={() => handleOpenFormDialog(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogTitle id="alert-dialog-title"><Typography className="gucci_text_bold" variant="h5">
                            New wishlist
                        </Typography></DialogTitle>
                        <DialogContent>
                            <TextField id="wishlist_name" label="Name your wishlist" variant="standard"
                                       onChange={(e) => {
                                           handleChangeName(e)
                                       }}/>
                            <div id='client_new_wishlist_dialog'>
                                <TextField id="wishlist_client" label="Client name" variant="standard"
                                           onChange={(e) => {
                                               handleChangeClient(e)
                                           }}/>
                            </div>
                            <div id='notes_new_wishlist_dialog'>
                                <TextField
                                    id="standard-multiline-flexible"
                                    label="Notes"
                                    multiline
                                    maxRows={4}
                                    value={noteValue}
                                    onChange={handleChangeNote}
                                    variant="standard"
                                    fullWidth
                                />
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleOpenFormDialog(false)} className="black template_button">
                                Cancel
                            </Button>
                            <Button onClick={() => addWishlist()} className="red template_button" autoFocus>
                                Create
                            </Button>
                        </DialogActions>
                    </Dialog>


                </div>

            }
        </div>
    );
}
